import MDB from '../marketingdb';

// const createSnowplowProxy = (functionName) => {
//     return function (){
//         if(!MDB.snowplow){
//             console.warn('MDB.snowplow not available');
//             return;
//         }
//        
//         const args = arguments;
//        
//         try{
//             MDB.Snowplow[functionName](...args);
//         }
//         catch(e){
//             //Ensure we don't crash when just executing some logging code
//             console.warn(e);
//         }
//     }
// };

const invokeSnowplow = (fn) => {
    try{
        fn(MDB.Snowplow);
    }
    catch(e){
        //Ensure we don't crash when just executing some logging code
        console.warn(e);
    }
};

export default {
    trackStructuredEvent: (category, action, label, property, value) => {
        invokeSnowplow(snowplow => snowplow.trackStructuredEvent(category, action, label, property, value));
    }
};